<div class="container-fluid content-wrapper">
  <h1 class="page-title">
    <img src="assets/svg/read-kid.svg" height="130px" class="logo-title" />
    Read Everything @ Every Level
    <img src="assets/svg/butterfly.svg" height="70px" class="logo-title" />
  </h1>

  <div class="content">
    <br/>
    <br/>
    <p class="word-counter">
      Paste In Content And Use The Dropdown To Select A Grade Level
    </p>

    <!-- Match Personality structure for textarea -->
    <div class="content-buttons col-12">
      <textarea
        id="inputText"
        [(ngModel)]="inputText"
        placeholder="Content To Be Transformed..."
        [disabled]="isLoading"
        rows="6"
        class="bottom-room"
        style="width: 100%;"></textarea>
    </div>

    <!-- Match Personality structure for submit button -->
    <div class="content-buttons col-12">
      <button
        (click)="onSubmit()"
        class="btn-baby-bigal"
        [class.w-100]="true"
        [disabled]="isLoading">
        {{ isLoading ? 'Processing...' : 'Submit' }}
      </button>
    </div>

    <br>

    <!-- BELOW HERE: original HTML remains unchanged per your instruction -->
    <div class="upload-section">
      <!-- <div class="files-uploader-wrapper">
        <label for="fileInput" class="btn-choose-bigal">
          <input id="fileInput" type="file" (change)="onFileSelected($event)"  />
          <i class="fas fa-folder bigal-folder"></i>&nbsp;
          <span class="mousebaby"> &nbsp; Choose File <br /><br /> </span>
        </label>
      
        <div *ngIf="selectedFile" class="file-details">
          <p class="selectedname"><strong>Selected:</strong> {{ selectedFile.name }}</p>
        </div>
      </div> -->

      <label class="ali-label">Choose <br>Reading <br>Level</label>
      <select [(ngModel)]="selectedReadingLevel" class="styled-dropdown" (change)="onReadingLevelSelected()">
        <option *ngFor="let level of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="level">
          {{ level }}th Grade
        </option>
      </select>
    </div>

    <br>
     <!-- Thinking Loading Animation -->
     <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>
 
    <!-- <div *ngIf="isLoading" class="loading">Generating Your Description...</div> -->

    <mat-tab-group #tabGroup [selectedIndex]="0">
      <mat-tab label="Lesson Plan">
        <ng-container *ngIf="transformedTess">
          <div class="images-grid">
            <div class="image-item"> 
              <img src="assets/svg/book-love.svg" height="20px;" alt="Uploaded Image" />
               <!-- Render formatted transformed text using Showdown -->
               <div [innerHTML]="formattedPlan"></div>
    
              <button class="btn-red-bigal" (click)="exportToPDF()">
                Export to PDF
              </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="btn-red-bigal" (click)="exportToDocs()">
                Export to DOCX
              </button>
            </div>
          </div>
        </ng-container>
      </mat-tab>

      <mat-tab label="Re-Written Content">
        <ng-container *ngIf="transformedText">
          <div class="images-grid">
            <div class="image-item"> 
              <img src="assets/svg/book-love.svg" height="99px;" alt="Uploaded Image" />
              <!-- Render formatted transformed text using Showdown -->
              <div [innerHTML]="formattedText"></div>

              <button class="btn-red-bigal" (click)="exportToPDF()">
                Export to PDF
              </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="btn-red-bigal" (click)="exportToDocs()">
                Export to DOCX
              </button>
            </div>
          </div>
        </ng-container>
      </mat-tab>

    </mat-tab-group>
    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  </div>
</div>
